export interface OrganizationAccountInfoFields {
  city?: string
  countryId?: string
  isSiretPendingAssignment?: boolean
  isVatExempted?: boolean
  name?: string
  registrationNo?: string
  street?: string
  vatNo?: string | null
  zipcode?: string
}

interface IsOrganizationAccountInfoCompleteOptions {
  organizationAccountInfo: OrganizationAccountInfoFields
}

export const isOrganizationAccountInfoComplete = ({
  organizationAccountInfo,
}: IsOrganizationAccountInfoCompleteOptions): boolean => {
  // The vatNo field is hidden for DK organizations (registrationNo covers that role) and is cleared
  // when the organization is VAT exempt, so it can't be filled in either case.
  const isVatNoApplicable = organizationAccountInfo.countryId !== 'DK' && !organizationAccountInfo.isVatExempted

  // registrationNo is disabled and left empty while a French organization is waiting for its SIRET
  // to be assigned, so it can't be filled in during that time.
  const isRegistrationNoApplicable = !organizationAccountInfo.isSiretPendingAssignment

  return Boolean(
    organizationAccountInfo.name &&
      (!isRegistrationNoApplicable || organizationAccountInfo.registrationNo) &&
      (!isVatNoApplicable || organizationAccountInfo.vatNo) &&
      organizationAccountInfo.street &&
      organizationAccountInfo.zipcode &&
      organizationAccountInfo.city,
  )
}
